/*
 * @Author: bianbinbin
 * @Date: 2023-12-15 16:31:52
 * @LastEditors: bianbinbin
 * @LastEditTime: 2023-12-15 16:33:10
 * @PageTitle: 页面...
 * @Description: 描述...
 * @FilePath: /ejx-web/src/router/module/risk-month-trend.js
 */
const riskMonthTrend = r =>
  require.ensure([], () => r(require('@/views/riskMonthTrend/riskMonthTrend.vue'), 'riskMonthTrend'))

const router = [
  {
    path: '/riskMonthTrend',
    name: 'riskMonthTrend',
    meta: {
      title: '风险月趋势'
    },
    component: riskMonthTrend
  }
]

export default router
